export default __webpack_public_path__ + "static/fa-brands-400-23f19bb08961f37aaf692ff943823453.eot";